import { Component, OnInit, OnDestroy } from '@angular/core';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-production-warning-banner',
  templateUrl: './production-warning-banner.component.html',
  styleUrls: ['./production-warning-banner.component.scss']
})
export class ProductionWarningBannerComponent implements OnInit, OnDestroy {
  
  get shouldShowWarning(): boolean {
    return environment.showProductionWarning || false;
  }

  ngOnInit() {
    if (this.shouldShowWarning) {
      document.body.classList.add('has-production-banner');
      // Agregar también al main-wrapper para asegurar que el contenido se desplace
      const mainWrapper = document.querySelector('.main-wrapper');
      if (mainWrapper) {
        mainWrapper.classList.add('has-production-banner');
      }
    }
  }

  ngOnDestroy() {
    document.body.classList.remove('has-production-banner');
    // Remover también del main-wrapper
    const mainWrapper = document.querySelector('.main-wrapper');
    if (mainWrapper) {
      mainWrapper.classList.remove('has-production-banner');
    }
  }

  navigateToProduction(): void {
    window.open('https://www.pmc-app.com', '_blank');
  }
}
